import { useAppDispatch } from "hooks/reduxHooks";
import { Button, Grid, Typography } from "@mui/material";
import { onContentSelected } from "store/servicioWhatsapp/servicioWhatsappSlice";
import { useServiceWhatsApp } from "hooks/servicioWhastApp/useWhatsApp";

export const ActualizarServicio = () => {
  const dispatch = useAppDispatch();
  const { telefonoWhatsapp } = useServiceWhatsApp();

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        xl={12}
        margin={2}
        textAlign={"start"}
        justifyContent={"center"}
      >
        <Typography variant="body1">
          El servicio de Notificación vía mensajeria instantánea ya se encuentra
          activo con el numero <b>{telefonoWhatsapp}</b>.
        </Typography>
        <Typography variant="body1" sx={{ marginTop: "10px" }}>
          ¿Desear realizar algún cambio?
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        xl={12}
        margin={2}
        display={"flex"}
      >
        <Button
          style={{ marginRight: "5px" }}
          variant="outlined"
          onClick={() => dispatch(onContentSelected("cancelarServicio"))}
        >
          Cancelar Servicio
        </Button>
        <Button
          variant="contained"
          onClick={() => dispatch(onContentSelected("avisoDePrivacidad"))}
        >
          Actualizar número
        </Button>
      </Grid>
    </Grid>
  );
};
